import React from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const TextEditor = ({ text, setText, rtl }) => {
  const handleEditorChange = (event, editor) => {
    const data = editor.getData();
    setText(data);
  };

  return (
    <div
      className={rtl ? "text-editor-rtl" : "text-editor-ltr"}
      dir={rtl ? "rtl" : "ltr"}
    >
      <CKEditor
        editor={ClassicEditor}
        data={text}
        onChange={handleEditorChange}
        config={{
          placeholder: rtl ? "اكتب الملاحظات هنا" : "Start typing here...",
        }}
      />
    </div>
  );
};

export default TextEditor;
